// extracted by mini-css-extract-plugin
module.exports = {"container":"error-module__container___1yedK","content":"error-module__content___3-H_v","text":"error-module__text___17ocL","link":"error-module__link___1n3U1"};